import "../../../index.css";
import Export from "./Export";
const AddPodcast = () => {
    return (
        <Export/>)
}
export default AddPodcast;
